// apiDateFormat is deprecated - use formatIsoDate instead
import { formatIsoDate } from 'utils/dateFormatter';

export default formatIsoDate;
